// HOME · Décor — reveal-on-scroll + particules + miettes au curseur
// Port/refactor de la logique maquette L3664-3766. Tout est garanti dégradable
// (prefers-reduced-motion, hover: none).

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)'
const FINE_POINTER = '(hover: hover)'

const REVEAL_SAFETY_MS = 1600
const REVEAL_THRESHOLD = 0.05

const HERO_PARTICLES = 26
const CREATEUR_PARTICLES = 22
const SIZE_MIN = 1
const SIZE_RANGE = 3
const PCT = 100
const DX_SPREAD = 80
const DX_HALF = 40
const DUR_MIN = 14
const DUR_RANGE = 18
const DEL_MAX = 25
const OPA_MIN = 0.35
const OPA_RANGE = 0.55

const CRUMB_MIN_DELAY_MS = 55
const CRUMB_LIFETIME_MS = 1650
const CRUMB_SIZE_MIN = 10
const CRUMB_SIZE_RANGE = 12
const FULL_TURN = 360

const rnd = (min, max) => min + Math.random() * (max - min)

function initReveal() {
  const els = Array.from(document.querySelectorAll('.home .rv'))
  if (!els.length) {
    return
  }
  const reveal = (el) => el.classList.add('in')

  if (!('IntersectionObserver' in window)) {
    els.forEach(reveal)
    return
  }
  window.setTimeout(() => els.forEach(reveal), REVEAL_SAFETY_MS)
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        reveal(e.target)
        io.unobserve(e.target)
      }
    })
  }, {
    threshold: REVEAL_THRESHOLD,
    rootMargin: '0px 0px -40px 0px'
  })
  els.forEach((el) => io.observe(el))
}

function populate(container, count, kind) {
  if (!container) {
    return
  }
  const frag = document.createDocumentFragment()
  for (let i = 0; i < count; i++) {
    const s = document.createElement('span')
    s.className = kind
    const size = SIZE_MIN + Math.random() * SIZE_RANGE
    s.style.width = `${size}px`
    s.style.height = `${size}px`
    s.style.left = `${Math.random() * PCT}%`
    s.style.setProperty('--dx', `${(Math.random() * DX_SPREAD - DX_HALF).toFixed(0)}px`)
    s.style.setProperty('--dur', `${(DUR_MIN + Math.random() * DUR_RANGE).toFixed(1)}s`)
    s.style.setProperty('--del', `${(-Math.random() * DEL_MAX).toFixed(1)}s`)
    s.style.setProperty('--opa', `${(OPA_MIN + Math.random() * OPA_RANGE).toFixed(2)}`)
    frag.appendChild(s)
  }
  container.appendChild(frag)
}

function initParticles() {
  populate(document.getElementById('hero-particles'), HERO_PARTICLES, 's')
  populate(document.getElementById('createur-particles'), CREATEUR_PARTICLES, 'g')
}

function initCrumbs() {
  const colors = ['#2a180c', '#3d2515', '#4a2d18', '#5c3a21', '#7e4a28', '#a8743f']
  const shapes = ['crumb--s1', 'crumb--s2', 'crumb--s3']
  const layer = document.createElement('div')
  layer.className = 'crumb-layer'
  document.body.appendChild(layer)

  let last = 0
  document.addEventListener('mousemove', (e) => {
    const now = performance.now()
    if (now - last < CRUMB_MIN_DELAY_MS) {
      return
    }
    last = now
    const c = document.createElement('span')
    c.className = `crumb ${shapes[Math.floor(Math.random() * shapes.length)]}`
    const dx = (Math.random() - 0.5) * 28
    const dy = (Math.random() - 0.5) * 12
    c.style.setProperty('--x', `${e.clientX}px`)
    c.style.setProperty('--y', `${e.clientY}px`)
    c.style.setProperty('--sz', `${rnd(CRUMB_SIZE_MIN, CRUMB_SIZE_MIN + CRUMB_SIZE_RANGE).toFixed(1)}px`)
    c.style.setProperty('--clr', colors[Math.floor(Math.random() * colors.length)])
    c.style.setProperty('--rot', `${rnd(0, FULL_TURN).toFixed(0)}deg`)
    c.style.setProperty('--dx', `${dx.toFixed(1)}px`)
    c.style.setProperty('--dy', `${dy.toFixed(1)}px`)
    c.style.setProperty('--dx2', `${(dx + (Math.random() - 0.5) * 36).toFixed(1)}px`)
    c.style.setProperty('--dy2', `${(dy + 40 + Math.random() * 50).toFixed(1)}px`)
    c.style.setProperty('--opa', `${rnd(0.8, 1).toFixed(2)}`)
    layer.appendChild(c)
    window.setTimeout(() => c.remove(), CRUMB_LIFETIME_MS)
  }, {
    passive: true
  })
}

export function initHomeDecor() {
  const reduced = window.matchMedia(REDUCED_MOTION).matches
  initReveal()
  if (reduced) {
    return
  }
  initParticles()
  if (window.matchMedia(FINE_POINTER).matches) {
    initCrumbs()
  }
}
